import moment from 'moment';
import i18n from 'i18next';

/**
 * Format date
 *
 * @param {string} date Date to be formatted
 * @param {string} format Desired date format
 * @returns {string} Formatted date
 */
export default (date, format = i18n.t('Common:localDateFormat', 'DD-MMM-YYYY')) => {
  if (!date) return '';

  let parsedDate;

  // Try parsing as DD/MM/YYYY if it matches that pattern
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    parsedDate = moment(date, 'DD/MM/YYYY', true);
  } else {
    parsedDate = moment(date); // fallback (ISO, timestamps, etc.)
  }

  // If parsing failed, return empty
  if (!parsedDate.isValid()) return '';

  return parsedDate.format(format);
};
